import { GALLERY } from "../data/menu";

export const Gallery = () => {
  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="relative bg-[#0A0A0A] text-white pt-8 pb-16 sm:pt-12 sm:pb-24 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-orange-500" />
              <span className="text-[11px] uppercase tracking-[0.35em] text-orange-400 font-semibold">
                Galería · Foto real
              </span>
            </div>
            <h2 className="font-display uppercase text-5xl sm:text-6xl leading-[0.95] tracking-tighter">
              Así se come <br />
              <span className="text-red-600">en Popeye.</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-md text-base">
            Fotos reales del restaurante y nuestros platillos.{" "}
            <span className="text-orange-400">Sin filtros, sin trampas.</span>
          </p>
        </div>

        {/* Mosaic — patrón tetris repetible cada 5 items */}
        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[140px] sm:auto-rows-[200px] lg:auto-rows-[280px] gap-2 sm:gap-4">
          {GALLERY.map((img, idx) => {
            // Patrón cíclico (mod 5): big, wide, small, small, wide
            const pattern = [
              "col-span-2 row-span-2", // big
              "col-span-2 row-span-1", // wide
              "col-span-1 row-span-1", // small
              "col-span-1 row-span-1", // small
              "col-span-2 row-span-1", // wide
            ];
            const span = pattern[idx % pattern.length];
            return (
              <figure
                key={idx}
                data-testid={`gallery-item-${idx}`}
                className={`relative group overflow-hidden border border-white/10 hover:border-orange-500/60 transition-colors ${span}`}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  style={{
                    objectPosition: img.position || "center",
                    transform: `scale(${img.zoom || 1})`,
                    transformOrigin: img.position || "center",
                  }}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.5]"
                />
                {/* Sin overlay sobre la foto — etiqueta compacta solamente */}
                <span
                  aria-hidden
                  className="absolute top-0 right-0 w-10 h-10 border-t-2 border-r-2 border-orange-500 opacity-0 group-hover:opacity-100 transition-opacity"
                />
                <figcaption className="absolute left-2 bottom-2 sm:left-3 sm:bottom-3 flex items-center gap-2">
                  <span className="text-[10px] sm:text-[11px] uppercase tracking-[0.25em] text-orange-400 font-semibold bg-black/60 backdrop-blur-md border border-white/10 px-2 py-1">
                    {img.tag}
                  </span>
                </figcaption>
                <span className="absolute top-2 right-2 sm:top-3 sm:right-3 font-display text-xs sm:text-sm uppercase tracking-widest text-white/80 bg-black/50 backdrop-blur-md px-1.5 py-0.5 border border-white/10">
                  0{idx + 1}
                </span>
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
};
